import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import Translate from '../../components/translate/Translate';
import './SwitchModeModal.scss';

interface SwitchModeModalProps {
    ctrl: {
        isVisible: boolean;
        confirm: () => void;
        cancel: () => void;
        onHideHandler: () => void;
    };
}

const SwitchModeHeader = () => (
    <div className='modal-header'>
        <h3 className='modal-title'>
            <Translate text='REACT.FLOATING_TOOLBAR.WIFI_VISUAL_SCAN_MODAL.HEADER' />
        </h3>
    </div>
);

const SwitchModeBody = () => (
    <div className='modal-body'>
        <p>
            <Translate text='REACT.FLOATING_TOOLBAR.WIFI_VISUAL_SCAN_MODAL.CONTENT' />
        </p>
    </div>
);

const SwitchModeFooter = ({onConfirm, onCancel}: any) => (
    <div className='modal-footer'>
        <button className='btn btn-primary' onClick={onConfirm}>
            <Translate text='REACT.FLOATING_TOOLBAR.WIFI_VISUAL_SCAN_MODAL.CONTINUE' />
        </button>
        <button className='btn btn-primary btn-cancel' onClick={onCancel}>
            <Translate text='REACT.FLOATING_TOOLBAR.WIFI_VISUAL_SCAN_MODAL.CANCEL' />
        </button>
    </div>
);

@observer
export class SwitchModeModal extends TechseeBaseComponent<SwitchModeModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <GenericModal
                className='switch-mode-modal'
                header={() => <SwitchModeHeader />}
                content={() => <SwitchModeBody />}
                toolbar={() => <SwitchModeFooter onConfirm={ctrl.confirm} onCancel={ctrl.cancel} />}
                onHideHandler={ctrl.onHideHandler}
                show={ctrl.isVisible}
            />
        );
    }
}
